import { Outlet } from 'react-router-dom';
import { LogisticsComponent } from '@lp/features/RoutePlanner/LogisticsComponent';

export const CaseLogisticsPlanner = () => (
  <>
    <LogisticsComponent />
    <Outlet />
  </>
);
